import { MobiDocument } from './MobiDocument';
import { TarifActiviteElementFriseDocument } from './TarifActiviteElementFriseDocument';

export class TarifActiviteDocument extends MobiDocument {
    private _id: string;
    private _rev: string;
    private id: number;
    private activite_id: number;
    private type: string;
    private intitule: string;
    private heure_debut: string;
    private heure_fin: string;
    private plageetou: string;


    //Attributs for Vuejs
    private isAuto: boolean;
    private elementfrise_id: Array<number>;

    public constructor(tarifelem: any) {
        super()
        this._id = tarifelem._id;
        this._rev = tarifelem._rev;
        this.id = tarifelem.id;
        this.activite_id = tarifelem.activite_id;
        this.type = tarifelem.type;
        this.intitule = tarifelem.intitule;
        this.heure_debut = tarifelem.heure_debut;
        this.heure_fin = tarifelem.heure_fin;
        this.plageetou = tarifelem.plageetou;
        this.isAuto = false;
        this.elementfrise_id = [];
    }


    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getActivite_id(): number {
        return this.activite_id;
    }

    public setActivite_id(activite_id: number): void {
        this.activite_id = activite_id;
    }

    public getType(): string {
        return this.type;
    }

    public setType(type: string): void {
        this.type = type;
    }

    public getPlageIntitule(): string {
        return this.intitule;
    }

    public setIntitule(intitule: string): void {
        this.intitule = intitule;
    }

    public getHeure_debut(): string {
        return this.heure_debut;
    }

    public setHeure_debut(heure_debut: string): void {
        this.heure_debut = heure_debut;
    }

    public getHeure_fin(): string {
        return this.heure_fin;
    }

    public setHeure_fin(heure_fin: string): void {
        this.heure_fin = heure_fin;
    }


    public getPlageetou(): string {
        return this.plageetou;
    }

    public setPlageetou(plageetou: string): void {
        this.plageetou = plageetou;
    }


    public isIsAuto(): boolean {
        return this.isAuto;
    }

    public setIsAuto(isAuto: boolean): void {
        this.isAuto = isAuto;
    }

    public getElementfrise_id(): Array<number> {
        return this.elementfrise_id;
    }

    public setElementfrise_id(elementfrise_id: Array<number>): void {
        this.elementfrise_id = elementfrise_id;
    }

    public getTarifActiviteElementFrise() : Array<TarifActiviteElementFriseDocument>{
        return this.memdb.find({
            doctype: "TarifActiviteElementFriseDocument",
            fkey: "tarifactivite_id",
            fvalue: this.id
        });
    }

}